import builder from '../builder';
import ArrowButtonLeft from '../../streamline-icons/bold/arrow-button-left.svg';
export default builder('IconArrowButtonLeftBold', ArrowButtonLeft);
//# sourceMappingURL=ArrowButtonLeft.js.map